import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import global from "../../scss/dhp.scss";

import { EditorContext } from "./EditorLayout";
import { EditorPanelContext } from "./EditorPanel";
import PageSize from "../../components/Editor/Toolbar/PageSize";
import BackgroundColor from "../../components/Editor/ContextualMenu/BackgroundColor";
import ContextualMenubar from "./ContextualMenubar";
import CollageActions from "../../components/Editor/ContextualMenu/CollageActions";
import AudioContextualMenubar from "./AudioContextualMenubar";
import { Icon } from "../../components/ui/icon";
import FrameActions from "../../components/Editor/ContextualMenu/FrameActions";

let style = Object.assign({}, global);

const EditorToolbar = props => {
  let { metadata, isDocumentSigned, isFrameContentActive, disableEditor } = useContext(EditorContext);
  const { collageData } = useContext(EditorPanelContext);

  // Stop any played video on active widget change or deselect
  useEffect(() => {
    if (isFrameContentActive) return;
    document.querySelectorAll(".dhp-page-widget[data-playing='true']").forEach(widget => {
      if (
        (widget.id !== metadata.activeWidgetId[0] || metadata.activeWidgetId?.length > 1) &&
        widget.querySelector("video")
      ) {
        widget.setAttribute("data-playing", "false");
        widget.querySelector("video")?.pause();
      }
    });
  }, [metadata.activeWidgetId]);

  return (
    <div className={style["toolbar"]}>
      {(isDocumentSigned || disableEditor) && (
        <ul className={style["toolbar-group"]}>
          <li className={cx(style["toolset-group"], [style["active"]])}>
            <div className={cx(style["toolset-item"], style["lock-wrap"])}>
              <span className={cx(style["toolset-action"], style["cursor-not-allowed"])}>
                <Icon icon="ui-lock2" />
              </span>
            </div>
          </li>
        </ul>
      )}

      {!isDocumentSigned && !disableEditor && !metadata.activeWidgetId && !collageData.isActive && !isFrameContentActive && (
        <ul className={style["toolbar-group"]}>
          {metadata.activeAudioId && <AudioContextualMenubar />}

          {!metadata.activeAudioId && metadata.activeOutSideCanvasArea && <PageSize />}

          {!metadata.activeAudioId && !metadata.activeOutSideCanvasArea && <BackgroundColor toggle={props.toggle} />}
        </ul>
      )}

      {!isDocumentSigned && !disableEditor && !metadata.activeWidgetId && collageData.isActive && <CollageActions />}

      {!isDocumentSigned && !disableEditor && !metadata.activeWidgetId && isFrameContentActive && <FrameActions />}

      {!isDocumentSigned && !disableEditor && metadata.activeWidgetId && <ContextualMenubar toggle={props.toggle} />}
    </div>
  );
};

EditorToolbar.propTypes = {
  toggle: PropTypes.func,
};

export default EditorToolbar;
